import { Component } from 'react';

class ObserverHoc extends Component<any, any> {
  private containerRef: (element: any) => void;
  private element: HTMLElement;
  private observer: IntersectionObserver;
  constructor(args: any) {
    super(args);
    this.state = {
      inView: false,
    };
    this.containerRef = element => {
      this.element = element;
    };
  }
  public componentDidMount() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: this.props.threshold || 0.5,
    };
    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.element);
  }

  private handleObserver(entities: any) {
    if (entities[0].isIntersecting && !this.state.inView) {
      this.setState({ inView: true });
      this.props.insideView(this.props.identifier, true);
    } else {
      if (this.state.inView) {
        this.setState({ inView: false });
      }
      if (this.props.outsideView) {
        if (
          entities[0].isIntersecting.boundingClientRect &&
          entities[0].isIntersecting.boundingClientRect.top
        ) {
          this.props.outsideView(this.props.identifier, false, true);
        } else {
          this.props.outsideView(this.props.identifier, false, false);
        }
      }
    }
  }
  private moveOnTop() {
    this.element.scrollIntoView({ behavior: 'smooth' });
    // this.setState({inView:true},()=> )
  }

  public componentDidUpdate(prevProp: any) {
    if (prevProp.isActive !== this.props.isActive) {
      if (this.props.isActive && !this.state.inView) {
        this.moveOnTop();
      }
    }
  }
  public render() {
    return (
      <div ref={this.containerRef} style={{ scrollMarginTop: '10rem' }}>
        {this.props.render(this.state)}
      </div>
    );
  }
}

export default ObserverHoc;



// WEBPACK FOOTER //
// ./components/common/observerHoc.tsx